<template>
    <b-row class="inline-input form-group">
        <b-col sm="12" md="4">
            <span class="text-uppercase text-type-inline-input">{{ $t('signupOH.birthDate') }}</span>
        </b-col>
        <b-col class="pr-2">
            <b-form-input type="number" v-model="day" placeholder="DD" :label="showLabels ? $t('signupOH.dayBirth') : null" :min="1" :max="31"/>
        </b-col>
        <b-col class="pr-2">
            <b-form-input type="number" v-model="month" placeholder="MM" :label="showLabels ? $t('signupOH.monthBirth') : null" :min="1" :max="12"/>
        </b-col>
        <b-col>
            <b-form-input type="number" v-model="year" placeholder="YYYY" :label="showLabels ? $t('signupOH.yearBirth') : null" :min="1900" :max="new Date().getUTCFullYear()"/>
        </b-col>
        <b-form-invalid-feedback v-if="dateIsCompleted" :state="dateIsValid">{{$t('signupOH.invalidDate')}}</b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="dateIsCompleted" :state="minorsAllowed || dateIs18YearsOldOrMore">{{ $t('signupOH.errors.birthdateMore18') }}</b-form-invalid-feedback>
    </b-row>
</template>

<script>
import { BFormInvalidFeedback, BFormInput } from 'bootstrap-vue'
import { dateIsBeforeToday } from '@/helpers/date.helpers'

export default {
    components: {
        BFormInvalidFeedback,
        BFormInput
    },
    props: {
        value: Date,
        minorsAllowed: {
            type: Boolean,
            required: false,
            default: false
        },
        showLabels: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            day: null,
            month: null,
            year: null
        }
    },
    computed: {
        date () {
            if (!this.dateIsCompleted) { return null }
            return new Date(Date.UTC(this.year, this.month - 1, this.day))
        },
        dateIsCompleted () {
            return this.day && this.day.length > 0 && parseInt(this.day) > 0 && this.month && this.month.length > 0 && parseInt(this.month) > 0 && this.year && this.year.length === 4 && this.year > 1900 && this.year
        },
        dateIsValid () {
            return this.date && this.date.getUTCMonth() === this.month - 1 && this.date.getUTCDate() === parseInt(this.day) && this.date.getUTCFullYear() === parseInt(this.year) &&
            this.date.getFullYear() >= 1900 && dateIsBeforeToday(this.date) && (this.minorsAllowed || this.dateIs18YearsOldOrMore)
        },
        dateIs18YearsOldOrMore () {
            if (!this.dateIsCompleted) { return true }
            const today = new Date()
            const eighteenYearsAgo = new Date(today.getUTCFullYear() - 18, today.getUTCMonth(), today.getUTCDate())
            return this.date <= eighteenYearsAgo
        },
        localValue: {
            get () {
                return this.dateIsValid ? `${this.year}-${this.month}-${this.day}` : null
            }
            /* set (newValue) {
                if (newValue && typeof newValue === 'string') {
                    // Split newValue date from xx-xx-xxxx to data
                    const date = newValue.split('-')
                    this.day = date[2]
                    this.month = date[1]
                    this.year = date[0]
                } else if (typeof newValue === 'object') {
                    this.day = newValue.getDate()
                    this.month = newValue.getMonth() + 1
                    this.year = newValue.getFullYear()
                }
            } */
        }
    },
    created () {
        this.localValue = this.value
        this.$watch('value', value => {
            this.localValue = value
        })
        this.$watch('localValue', value => {
            this.$emit('input', this.date)
            this.$emit('change', this.date)
        })
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/base/forms/BaseBirthdateInput.vue